import type { UseCase } from '@contexts/shared/application';
import { enumValueObject, stringValueObject, uuidValueObject } from '@contexts/shared/domain';
import {
	type Role,
	RoleOptions,
	type UpdateUserInput,
	type User,
	type UserRepository
} from '@contexts/users/domain';

import { type Language, LanguageOptions } from '../../domain/models/language';

export type UpdateUserUseCase = UseCase<UpdateUserInput, User>;

export function updateUserBuilder(userRepository: UserRepository): UpdateUserUseCase {
	return async function updateUser(user: UpdateUserInput): Promise<User> {
		const id = uuidValueObject().validate('id', user.id);
		const firstName = stringValueObject().validate('firstName', user.firstName);
		const lastName = stringValueObject().validate('lastName', user.lastName);
		const language = enumValueObject<LanguageOptions, Language>()
			.setEnum(LanguageOptions)
			.validate('language', user.language);
		const phone = stringValueObject().validate('phone', user.phone);
		const role = enumValueObject<RoleOptions, Role>()
			.setEnum(RoleOptions)
			.validateOptional('role', user.role);
		const delegationId =
			user.delegationId && uuidValueObject().validateOptional('id', user.delegationId);

		const newUser: UpdateUserInput = {
			id,
			firstName,
			lastName,
			language,
			phone,
			role,
			delegationId
		};
		return userRepository.update(newUser);
	};
}
